import { Box, Typography } from "@mui/material";
import React from "react";
import "./crm-no-cost-plans.scss";
import {
  AlertComponent,
  BreadcrumbComponent,
} from "../../../../common/components";
import { routes } from "../../../../constants/routes";
import ViewPlanDetails from "../crm-paid-plans/view-plan-details";
import { AntSwitch } from "../../../user-management/user-management-list/components/ant-switch";
import { getSubscriptionPlans } from "../../../../api/tenets";
import { AlertMessage } from "../../tenant-details/tenant-details-types";
import { getNoCostPlans, validationSchema } from "../crm-plans-utils";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { Form, Formik } from "formik";
import { toggleCRMPlanStatus } from "../../../../api/crm-plans";

const labelSwitch = { inputProps: { "aria-label": "Switch demo" } };

const CrmNoCostPlans = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [plans, setPlans] = React.useState<any>([]);
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    open: false,
  });

  const getSubscriptionValues = async () => {
    try {
      setIsLoading(true);
      const response = await getSubscriptionPlans({planCategory: 'no cost'});
      const resPlans = response?.data?.data || [];

      const { plans } = getNoCostPlans(resPlans);
      setPlans(plans);
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
      console.error(e);
    }
  };

  React.useEffect(() => {
    getSubscriptionValues();
  }, []);

  const handleActiveToggle = async (planId: any, payload: any) => {
    try {
      setIsLoading(true);
      const res = await toggleCRMPlanStatus(planId, payload);

      const updatedPlans = plans.map((plan: any) =>
        plan.id === planId ? { ...plan, active: payload.status } : plan
      );
      setPlans(updatedPlans);
      setAlertMessage({
        open: true,
        message:
          res?.data?.data?.message || "Active status updated successfully.",
        type: "success",
      });
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);

      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
    }
  };

  const showLoading = React.useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  const breadcrumbLink = [
    {
      label: "CRM Plans",
      handleClick: () => {},
    },
    {
      label: "No Cost Plans",
      link: routes.CREATE_CRM_PLAN,
      handleClick: () => {},
    },
  ];

  return (
    <Box className="crm-no-cost-plan-wrapper">
      <Box>
        <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
      </Box>
      <Box className="crm-no-cost-plan-content">
        <Box>
          <Box className="paid-plans-switch">
            <AntSwitch
              {...labelSwitch}
              checked={plans?.[0]?.active || false}
              onChange={(e) => {
                // setFieldValue("status", e.target.checked ? "ACTIVE" : "INACTIVE")
                handleActiveToggle(plans?.[0]?.id, {
                  status: !plans?.[0]?.active,
                });
              }}
            />
            <Typography className="paid-plans-status">Active</Typography>
          </Box>
        </Box>
        <Formik
          initialValues={plans?.[0] || {}}
          validationSchema={validationSchema}
          enableReinitialize
          validateOnBlur
          onSubmit={(values) => {
            // addTenet(temp, values);
          }}
        >
          {({}) => (
            <Form>
              <ViewPlanDetails
                activeTab={0}
                title="No Cost"
                plans={plans[0]}
                setPlans={setPlans}
                allPlans={plans}
              />
            </Form>
          )}
        </Formik>
      </Box>
      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </Box>
  );
};

export default CrmNoCostPlans;
